import { render, staticRenderFns } from "./businessDepartment.vue?vue&type=template&id=09d25174&scoped=true"
import script from "./businessDepartment.vue?vue&type=script&lang=js"
export * from "./businessDepartment.vue?vue&type=script&lang=js"
import style0 from "./businessDepartment.vue?vue&type=style&index=0&id=09d25174&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d25174",
  null
  
)

export default component.exports